export const FIELD_TYPE = {
  checkbox: '33d6a94f-1da6-41ab-b472-53bf86048768',
  text: '9cce0514-09f7-4111-8bc4-ce7832f04907',
  dropdown: '97b56610-fa12-40ce-97db-36ffff06592e',
  radio: 'ecf7437a-67e1-460a-b73d-f19a08685887',
  image: 'd3caefa6-fda1-43e9-aa59-f1496d04362c',
  counter: '0c891980-d7c2-49f9-a659-ceb2216523f9',
  datetime: 'd9d55ed2-29ef-42e8-b5bf-3db7f5715d0c',
  number: '63e171c8-bb7d-4d5b-8138-8247b3786456',
  label: '0092f952-b372-4110-97fc-9ded7274ec0f'
};
